import Logger from 'observability/Logger';

const LOG = new Logger('font-utils');

/**
 * Extracts fonts from Cake bootstrap data
 * @param {string} fontsPalettes
 * @return {Object[]}
 */
export const parseFontsFromCmsBootstrapFormat = (fontsPalettes) => {
    let fonts;
    try {
        const { fonts: parsedFonts } = JSON.parse(fontsPalettes);
        fonts = parsedFonts.split(';');
    } catch (e) {
        LOG.error(e);
        fonts = [];
    }

    return fonts.map((font, i) => ({ id: i, value: font }));
};

/**
 * Transforms a font into an object
 * @param {string} font
 */
export const transformFont = (font, i) => ({ id: i, value: font, name: font });
